import { z } from "zod";

export const DrivingLessonTypeEnum = z.enum([
  "normal",
  "ueberlandfahrt",
  "autobahnfahrt",
  "nachtfahrt",
  "simulator",
  "praktischePruefung",
  "schaltkompetenz",
  "theoretischePruefung",
  "fahrprobe",
  "unterweisungAmFahrzeug",
  "praktischeUnterweisung",
]);

export type DrivingLessonType = z.infer<typeof DrivingLessonTypeEnum>;
